import { useCallback, useEffect, useRef } from 'react';

export const useTooltip = () => {
  const tooltipRef = useRef<any>(null);

  const openTooltip = useCallback(() => {
    if (!tooltipRef.current) return;
    tooltipRef.current?.openTooltip?.();
  }, []);

  const closeTooltip = useCallback(() => {
    if (!tooltipRef.current) return;
    tooltipRef.current?.closeTooltip?.();
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', closeTooltip, true);
    return () => window.removeEventListener('scroll', closeTooltip, true);
  }, [closeTooltip]);

  return {
    tooltipRef,
    openTooltip,
    closeTooltip,
  };
};
